import type { TmWrappers } from '@/wrappers'

export type TmTicketsInboxForwardingProvider = 'gmail' | 'appleMail' | 'outlook' | 'yahooMail' | 'zohoMail'

export type TmTicketInboxForwardingOptions = {
  provider: TmTicketsInboxForwardingProvider
}

export const ticketsForwardingInstructionsModalId: TmWrappers = 'ticketsForwardingInstructionsModal'
